import React from 'react';
import './SectionService.css';
import { Helmet } from 'react-helmet';

const servicesData = [
  {
    imgSrc: "img/keyword-image/best-luxury-pg-in-pune.jpg",
    title: "Best Luxury PG in Pune",
    description: "Look no further than Om Sai PG. Located in the prime area of Kharadi, Pune, near EON IT Park, Om Sai PG offers an exceptional PG accommodation experience with luxurious facilities, tailored to meet the needs of working professionals, corporate employees, and students.",
    link: "/Best-Luxury-PG-in-Pune"
  },
  {
    imgSrc: "img/keyword-image/pg-for-student-in-kharadi.jpg",
    title: "PG for Students in Kharadi Pune",
    description: "If you're looking for a PG for students in Kharadi, Pune, Om Sai PG offers the perfect solution. Kharadi is not just an emerging commercial hub but also home to various educational institutions. For students attending college or university in Pune, Om Sai PG is the ideal place to stay, offering comfort, affordability, and a range of modern amenities designed to make student life easier.",
    link: "/PG-for-Students-in-Kharadi-Pune"
  },
  {
    imgSrc: "img/keyword-image/om-sai-pg-in-kharadi.jpg",
    title: "Om Sai PG Kharadi",
    description: "Om Sai PG Kharadi stands out as one of the top choices for students, working professionals, and anyone in need of a well-facilitated and secure living space. Located in the heart of Kharadi, one of Pune’s rapidly developing neighborhoods, Om Sai PG offers everything you need for a stress-free and comfortable stay. ",
    link: "/Om-Sai-PG-Kharadi"
  },

  {
    imgSrc: "img/keyword-image/Girls-hostel-in-kharadi.jpg",
    title: "Girls Hostels in Kharadi",
    description: "Om Sai Girls Hostel provides a safe, comfortable, and affordable living space for young women in one of Pune’s most vibrant and well-connected localities. Whether you’re a student or a working professional, our girls’ hostel in Kharadi offers all the amenities you need for a smooth and hassle-free stay. ",
    link: "/Girls-Hostels-in-Kharadi"
  },

  {
    imgSrc: "img/keyword-image/Kharadi-IT-park-near-pune.jpg",
    title: "Paying Guest Near Kharadi IT Park Pune",
    description: "If you're searching for a paying guest accommodation near Kharadi IT Park, Pune, look no further than Om Sai PG. Located strategically near the bustling EON IT Park, Om Sai PG offers comfortable, affordable, and well-equipped rooms for both working professionals and students",
    link: "/Paying-Guest-Near-Kharadi-IT-Park-Pune"
  },
  {
    imgSrc: "img/keyword-image/pg-for-working-professionals.jpg",
    title: "Paying Guest Near Kharadi IT Park Pune",
    description: "Finding a PG for working professionals in Pune can be a challenge, but Om Sai PG offers the ideal solution. With its strategic location in Kharadi, close to major IT parks, business hubs, and transport links, Om Sai PG provides a comfortable, convenient, and affordable living experience for working professionals.",
     link: "/PG-for-Working-Professionals-Pune"
  },
  
];

const ServicesSection = () => {
  return (
    <>
    <Helmet>
 
 <script type="application/ld+json">
   {JSON.stringify({
     "@context": "https://schema.org",
     "@type": "Organization",
     "name": "Om Sai PG",
     "description": "Om Sai PG offers affordable PG accommodations in Kharadi, Pune, with food, for students, working professionals, and residents, near Eon IT Park.",
     "url": "https://www.omsaipg.in",
     "logo": "https://www.omsaipg.in/images/logo.jpg",
     "image":"https://www.omsaipg.in/images/ogimage.jpg",
     "contactPoint": [
       {
         "@type": "ContactPoint",
         "telephone": "+91 9763888448",
         "contactType": "Customer Service",
         "areaServed": "IN",
         "availableLanguage": "English",
       },
       {
         "@type": "ContactPoint",
         "telephone": "+91 9922248255",
         "contactType": "Customer Service",
         "areaServed": "IN",
         "availableLanguage": "English",
       },
     ],
     "aggregateRating": {
       "@type": "AggregateRating",
       "bestRating": "5",
       "worstRating": "1",
       "ratingValue": "4.7",
       "ratingCount": "250",
     },
     "email": "omsaipg@gmail.com",
     "address": {
       "@type": "PostalAddress",
       "streetAddress": "Tulja Bhavani Nagar, Lane No 7, Near Durga Mata Mandir",
       "addressLocality": "Kharadi",
       "addressRegion": "Maharashtra",
       "postalCode": "411014",
       "addressCountry": "IN",
     },
     "sameAs": [
       "https://www.facebook.com/omsaipg",
       "https://www.instagram.com/omsaipg",
       "https://www.linkedin.com/company/omsaipg"
     ],
     "priceRange": "INR 8,500-6000",
     "paymentAccepted": "Cash, UPI, Credit Card",
     "telephone": "+91 9763888448",
     "email": "omsaipgpune@gmail.com",
     "keywords": [
       "PG in Pune",
       "PG in Kharadi",
       "PG with food in Pune",
       "PG for students in Kharadi",
       "PG for females in Pune",
       "PG for males in Pune",
       "Om Sai PG Kharadi",
       "Girls Hostels in Kharadi",
       "Boys Hostel in Kharadi",
       "Monthly Basis PG in Kharadi",
       "PG in Wagholi",
       "PG in Kharadi with food",
       "Hostels in Pune",
       "PG for Students in Kharadi Pune",
       "Paying Guest Hostel in Chandan Nagar"
     ],
     "openingHours": "Mo-Su 09:00-22:00"
   })}
 </script>

 {/* Title */}
 <title>
   Contact : +91 9763888448 / +91 9922248255 |Om Sai PG |Service | Paying Guest Near Kharadi IT Park Pune| PG Near Kharadi Eon IT Park | PG Near Kharadi Bypass | Wadgaon Sheri PG
 </title>

 {/* Meta Tags */}
 <meta
   name="description"
   content="Om Sai PG offers the best PG accommodations in Kharadi, Pune. We provide PG for students, males, females, with food and other essential amenities."
 />
 <meta
   name="keywords"
   content="PG in Pune, PG in Kharadi, Paying Guest Near Kharadi IT Park Pune,PG Near Kharadi Eon IT Park,PG Near Kharadi Bypass, Wadgaon Sheri PG"
 />
 <meta name="robots" content="index, follow" />

 {/* Open Graph Tags */}
 <meta
   property="og:title"
   content="Om Sai PG - Best PG Accommodation in Kharadi Pune | PG with Food | Paying Guest in Kharadi"
 />
 <meta
   property="og:description"
   content="Looking for the best PG in Kharadi Pune? Om Sai PG offers comfortable and affordable accommodation for students, professionals, and residents with food included."
 />
 <meta property="og:image" content="https://www.omsaipg.in/ogimage.jpg" />
 <meta property="og:url" content="https://www.omsaipg.in" />
 <meta property="og:type" content="website" />
</Helmet>

    <section className="section-services">
      <div className="container">
        {/* Section Title */}
        <div className="sec-title centered">
          <h2>Our <span>Services</span> </h2>
          <div className="sub-title">We provide best services for your stay at our place.</div>
          <div className="separator"></div>
        </div>

        {/* Service Items */}
        <div className="row clearfix">
          {servicesData.map((service, index) => (
            <div className="news-block col-md-4 col-sm-6 col-xs-12" key={index}>
              <div className="inner-box">
                <a href={service.link}>
                  <div className="image">
                    <img src={service.imgSrc} alt={service.title} />
                  </div>
                </a>
                <div className="lower-box">
                  <h3>
                    <a href={service.link} className='my-head'>{service.title}</a>
                  </h3>
                  <div className="text">{service.description}</div>
                  <div className="clearfix">
                    <div className="pull-left">
                      <a href={service.link} className="read-more">
                        Read More <span className="fa fa-angle-right"></span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
    </>
  );
};

export default ServicesSection;
